export function newExerptText(text, excerptMaxLength = 300) {
    if (typeof text !== "string") return text;

    if (text.length > excerptMaxLength) {
        let excerpt = text.substring(0, excerptMaxLength);
        excerpt += "...";
        return excerpt;
    }

    return text;
}

export function excerptText(
    text,
    excerptMaxLength = 300,
    useExtension = false
) {
    if (typeof text !== "string") return text;

    if (text.length > excerptMaxLength) {
        let excerpt = text.substring(0, excerptMaxLength);
        let e = excerpt.substring(0, excerpt.lastIndexOf(" "));
        if (e != "") {
            excerpt = e;
        }
        excerpt += "...";

        if (useExtension) {
            const items = text.split(".");
            const ext = `.${items[items.length - 1]}`;
            return `${excerpt}${ext}`;
        }

        return excerpt;
    }

    return text;
}

export function ararbicToPersian(input) {
    var obj = {
        ك: "ک",
        دِ: "د",
        بِ: "ب",
        زِ: "ز",
        ذِ: "ذ",
        شِ: "ش",
        سِ: "س",
        ى: "ی",
        ي: "ی",
        "١": "۱",
        "٢": "۲",
        "٣": "۳",
        "٤": "۴",
        "٥": "۵",
        "٦": "۶",
        "٧": "۷",
        "٨": "۸",
        "٩": "۹",
        "٠": "۰",
    };

    Object.keys(obj).forEach(function (key) {
        input = input.replace(new RegExp(key, "g"), obj[key]);
    });

    return input;
}

export function randomAlphaNumeric(length) {
    const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
}

export function getGender(gender) {
    if (gender === "M") {
        return "آقا";
    } else if (gender === "F") {
        return "خانم";
    }
    return gender;
}
